import React, { useContext } from "react"
import { StateContext } from "../../StateProvider"
import "react-responsive-carousel/lib/styles/carousel.min.css" // requires a loader
import { Carousel } from "react-responsive-carousel"

import ChoseButton from "../ChoseButton/choseButton"

// IMG
import closeSvg from "../../images/card_icons/close.svg"

import eis1 from "../../images/CardIDImages/eis-wagen/eis1.jpg"
import eis2 from "../../images/CardIDImages/eis-wagen/eis2.jpg"
import eis3 from "../../images/CardIDImages/eis-wagen/eis3.jpg"
import eis4 from "../../images/CardIDImages/eis-wagen/eis4.jpg"
import eis5 from "../../images/CardIDImages/eis-wagen/eis5.jpg"
import eis6 from "../../images/CardIDImages/eis-wagen/eis6.jpg"
import eis7 from "../../images/CardIDImages/eis-wagen/eis7.jpg"
import eis8 from "../../images/CardIDImages/eis-wagen/eis8.jpg"

import food1 from "../../images/CardIDImages/foodtruck/food1.jpg"
import food2 from "../../images/CardIDImages/foodtruck/food2.jpg"
import food3 from "../../images/CardIDImages/foodtruck/food3.jpg"
import food4 from "../../images/CardIDImages/foodtruck/food4.jpg"
import food5 from "../../images/CardIDImages/foodtruck/food5.jpg"

import foto1 from "../../images/CardIDImages/fotobox/foto1.jpg"
import foto2 from "../../images/CardIDImages/fotobox/foto2.jpg"

import rad1 from "../../images/CardIDImages/gluecksrad/rad1.jpg"
import rad2 from "../../images/CardIDImages/gluecksrad/rad2.jpg"

import burg1 from "../../images/CardIDImages/huepfburg/burg1.jpg"
import burg2 from "../../images/CardIDImages/huepfburg/burg2.jpg"
import burg3 from "../../images/CardIDImages/huepfburg/burg3.jpg"
import burg4 from "../../images/CardIDImages/huepfburg/burg4.jpg"

import kaffee1 from "../../images/CardIDImages/kaffeewagen/kaffe1.jpg"
import kaffee2 from "../../images/CardIDImages/kaffeewagen/kaffee2.jpg"

import kar1 from "../../images/CardIDImages/karussel/karussel1.jpg"
import kar2 from "../../images/CardIDImages/karussel/karussel2.jpg"
import kar3 from "../../images/CardIDImages/karussel/karussel3.jpg"
import kar4 from "../../images/CardIDImages/karussel/karussel4.jpg"
import kar5 from "../../images/CardIDImages/karussel/karussel5.jpg"
import kar6 from "../../images/CardIDImages/karussel/karussel6.jpg"
import kar7 from "../../images/CardIDImages/karussel/karussel7.jpg"

import schm1 from "../../images/CardIDImages/kinderschminken/schmink1.jpg"
import schm2 from "../../images/CardIDImages/kinderschminken/schmink2.jpg"
import schm3 from "../../images/CardIDImages/kinderschminken/schmink3.jpg"
import schm4 from "../../images/CardIDImages/kinderschminken/schmink4.jpg"

import pop1 from "../../images/CardIDImages/popcornmaschine/pop1.jpg"
import pop2 from "../../images/CardIDImages/popcornmaschine/pop2.jpg"
import pop3 from "../../images/CardIDImages/popcornmaschine/pop3.jpg"

import riesen1 from "../../images/CardIDImages/riesenrad/rad1.jpg"
import riesen2 from "../../images/CardIDImages/riesenrad/rad2.jpg"
import riesen3 from "../../images/CardIDImages/riesenrad/rad3.jpg"

import bar1 from "../../images/CardIDImages/schiffsbar/bar1.jpg"

import schlitten1 from "../../images/CardIDImages/schlittenbahn/schlitten1.jpg"
import schlitten2 from "../../images/CardIDImages/schlittenbahn/schlitten2.jpg"

import zelt1 from "../../images/CardIDImages/zirkuszelt/zelt1.jpg"
import zelt2 from "../../images/CardIDImages/zirkuszelt/zelt2.jpg"
import zelt3 from "../../images/CardIDImages/zirkuszelt/zelt3.jpg"
import zelt4 from "../../images/CardIDImages/zirkuszelt/zelt4.jpg"
import zelt5 from "../../images/CardIDImages/zirkuszelt/zelt5.jpg"

import "./CardModal.scss"

const CardModal = ({ id, close }) => {
  const [state] = useContext(StateContext)

  const imgSwitch = img => {
    switch (img) {
      case "eis1":
        return eis1
      case "eis2":
        return eis2
      case "eis3":
        return eis3
      case "eis4":
        return eis4
      case "eis5":
        return eis5
      case "eis6":
        return eis6
      case "eis7":
        return eis7
      case "eis8":
        return eis8
      case "food1":
        return food1
      case "food2":
        return food2
      case "food3":
        return food3
      case "food4":
        return food4
      case "food5":
        return food5
      case "foto1":
        return foto1
      case "foto2":
        return foto2
      case "rad1":
        return rad1
      case "rad2":
        return rad2
      case "burg1":
        return burg1
      case "burg2":
        return burg2
      case "burg3":
        return burg3
      case "burg4":
        return burg4
      case "kaffee1":
        return kaffee1
      case "kaffee2":
        return kaffee2
      case "kar1":
        return kar1
      case "kar2":
        return kar2
      case "kar3":
        return kar3
      case "kar4":
        return kar4
      case "kar5":
        return kar5
      case "kar6":
        return kar6
      case "kar7":
        return kar7
      case "schm1":
        return schm1
      case "schm2":
        return schm2
      case "schm3":
        return schm3
      case "schm4":
        return schm4
      case "pop1":
        return pop1
      case "pop2":
        return pop2
      case "pop3":
        return pop3
      case "riesen1":
        return riesen1
      case "riesen2":
        return riesen2
      case "riesen3":
        return riesen3
      case "bar1":
        return bar1
      case "schlitten1":
        return schlitten1
      case "schlitten2":
        return schlitten2
      case "zelt1":
        return zelt1
      case "zelt2":
        return zelt2
      case "zelt3":
        return zelt3
      case "zelt4":
        return zelt4
      case "zelt5":
        return zelt5
    }
  }

  const data = state.find(el => el.id === id)

  return (
    <div className="card-modal-container">
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="center">
          <div className="card-grid">
            <div className="image-gallery-wrapper">
              <Carousel
                autoPlay
                useKeyboardArrows
                interval="5000"
                transitionTime="1000"
                showArrows={false}
                showStatus={false}
              >
                {data.gal.map((item, i) => (
                  <div className="image-wrapper-gal" key={i}>
                    <img src={imgSwitch(item)} alt={item} />
                  </div>
                ))}
              </Carousel>
            </div>
            <div className="function-wrapper">
              <div className="head">
                <h2>{data.title}</h2>
                {/* =========== */}
                {/* =========== */}
                {/* =========== */}
                {/* =========== */}
                {/* =========== */}
                {/* =========== */}
                {/* <Link to="/#fahrgeschaefte"> */}
                <div className="close-card-id" onClick={close}>
                  <img src={closeSvg} alt="close" />
                </div>
                {/* </Link> */}
                {/* =========== */}
                {/* =========== */}
                {/* =========== */}
                {/* =========== */}
                {/* =========== */}
                {/* =========== */}
              </div>
              <div className="information-container">
                <ul>
                  {data.information.map(item => (
                    <li key={item.id}>
                      <p>{`${item.title}:`}</p>
                      <p>{`${item.value}`}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="price-wrapper">
                <p>Preise ab</p>
                <p>{data.price === 0 ? "Auf Anfrage" : data.price} €</p>
              </div>
              <ChoseButton id={id} />
            </div>

            <div className="text-wrapper-id">
              <h3>Beschreibung</h3>
              <p>{data.text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardModal
